<template>
	<!-- 内部用户编辑/新增 -->
	<div class="page-container" id="userManagementContainer">
		<el-form :model="userEditForm" :rules="userEditFormRules" ref="ruleFormRef" class="form-panel" label-position="top"
			:validateOnRuleChange="false">
			<el-col :span="24">
				<el-row class="content-panel">
                     <el-col style="margin-bottom:8px">
						<el-button type="primary" size="small" plain @click="handleAdd">新增用户</el-button>
            <el-button type="primary" size="small" plain @click="handleAdd">保存</el-button>
						<el-button type="danger" size="small" plain @click="handleResetPwd">重置密码</el-button>
						<el-button type="primary" size="small" plain @click="handleEnable">生效</el-button>
						<el-button type="danger" size="small" plain @click="handleDisable">失效</el-button>
                    </el-col>
						<el-row :gutter="22">
							<el-col :span="6">
								<el-form-item label="登录账号" prop="userName">
									<el-input size="mini" v-model="sysUser.userName"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="6">
								<el-form-item label="中文名称" prop="userNameCn">
									<el-input size="mini" v-model="sysUser.userNameCn"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="6">
								<el-form-item label="用户类型" prop="userType">
									<el-select multiple class="length_input" size="mini" v-model="sysUser.userType"
                                        placeholder="请选择">
                                        <el-option
                                        v-for="item in userTypelist"
                                        :key="item.key"
                                        :label="item.value"
                                        :value="item.key"
                                        >
                                        </el-option>
                                    </el-select>
								</el-form-item>
							</el-col>
							<el-col :span="6">
								<el-form-item label="性别" prop="sex">
									<el-select class="length_input" size="mini" v-model="sysUser.sex"
                                        placeholder="请选择">
                                        <el-option
                                        v-for="item in sex"
                                        :key="item.key"
                                        :label="item.value"
                                        :value="item.key"
                                        >
                                        </el-option>
                                    </el-select>
								</el-form-item>
							</el-col>
						</el-row>
						<el-row :gutter="22">
							<el-col :span="6">
								<el-form-item label="英文名称" prop="userNameEn">
									<el-input size="mini" v-model="sysUser.userNameEn"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="6">
								<el-form-item label="身份证号码">
									<el-input size="mini" v-model="sysUser.identityCardNo"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="6">
								<el-row :gutter="10">
                                    <el-col :span="12">
                                        <el-form-item label="电子邮箱/密码">
                                            <el-input size="mini" v-model="sysUser.email"></el-input>
								        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="">
                                            <label slot="label">&nbsp;</label>
                                            <el-input size="mini" v-model="sysUser.emailPassword"></el-input>
								        </el-form-item>
                                    </el-col>
                                </el-row>
							</el-col>
                            <el-col :span="6">
								<el-form-item label="邮箱别名">
									<el-input size="mini" v-model="sysUser.emailAlias"></el-input>
								</el-form-item>
							</el-col>
						</el-row>
                        <el-row :gutter="22">
							<el-col :span="6">
								<el-form-item label="手机号码" prop="mobilePhone">
									<el-input size="mini" v-model="sysUser.mobilePhone"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="6">
								<el-form-item label="办公电话" prop="tel">
									<el-input size="mini" v-model="sysUser.tel"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="6">
								<el-form-item label="传真" prop="fax">
									<el-input size="mini" v-model="sysUser.fax"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="6">
								<el-form-item label="微信号" prop="wechat">
									<el-input size="mini" v-model="sysUser.wechat"></el-input>
								</el-form-item>
							</el-col>
						</el-row>
                        <el-row :gutter="22">
							<el-col :span="6">
								<el-form-item label="QQ号码" prop="qq">
									<el-input size="mini" v-model="sysUser.qq"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="6">
								<el-form-item label="备注" prop="remark">
									<el-input size="mini" v-model="sysUser.remark"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="6">
								<el-form-item label="在职状态" prop="inserviceStatus">
									<el-select class="length_input" size="mini" v-model="sysUser.inserviceStatus"
                                        placeholder="请选择">
                                        <el-option
                                        v-for="item in inserviceStatus"
                                        :key="item.key"
                                        :label="item.value"
                                        :value="item.key"
                                        >
                                        </el-option>
                                    </el-select>
								</el-form-item>
							</el-col>
							<el-col :span="6">
								<el-form-item label="数据权限范围" prop="dataAuthorityId">
									<el-input size="mini" v-model="sysUser.dataAuthorityId"></el-input>
								</el-form-item>
							</el-col>
						</el-row>
                        <el-row :gutter="22">
							<el-col :span="6">
								<el-form-item label="有效标志" prop="isActive">
									<el-select class="length_input" size="mini" v-model="sysUser.isActive"
                                        placeholder="请选择" disabled>
                                        <el-option
                                        v-for="item in isActive"
                                        :key="item.key"
                                        :label="item.value"
                                        :value="item.key"
                                        >
                                        </el-option>
                                    </el-select>
								</el-form-item>
							</el-col>
							<el-col :span="6">
								<el-form-item label="生效时间" prop="activeStartTime">
									<el-date-picker
                                    v-model="sysUser.activeStartTime"
                                    align="right"
                                    type="date"
                                    size="mini"
                                    style="width:100%;"
                                    placeholder="选择日期"
                                    :picker-options="pickerOptions"
                                    disabled>
                                    </el-date-picker>
								</el-form-item>
							</el-col>
							<el-col :span="6">
								<el-form-item label="失效时间">
									<el-date-picker
                                    v-model="sysUser.activeEndTime"
                                    align="right"
                                    type="date"
                                    size="mini"
                                    style="width:100%;"
                                    placeholder="选择日期"
                                    :picker-options="pickerOptions"
                                    disabled>
                                    </el-date-picker>
								</el-form-item>
							</el-col>
							<el-col :span="6">
								<el-form-item label="用户来源" prop="userSource">
									<el-select class="length_input" size="mini" v-model="sysUser.userSource"
                                        placeholder="请选择"
                                        disabled>
                                        <el-option
                                        v-for="item in userSource"
                                        :key="item.key"
                                        :label="item.value"
                                        :value="item.key"
                                        >
                                        </el-option>
                                    </el-select>
								</el-form-item>
							</el-col>
						</el-row>
                    <el-row :gutter="22">
                        <el-col :span="6">
                            <el-form-item label="入职时间" prop="entryDate" >
                                <el-date-picker
                                v-model="sysUser.entryDate"
                                style="width: 100%"
                                align="right"
                                type="date"
                                size="mini"
                                placeholder="选择日期"
                                :picker-options="pickerOptions">
                            </el-date-picker>
                            </el-form-item>
                        </el-col>
                    </el-row>
                        <!-- <el-row :gutter="22">
							<el-col :span="6">
								<el-form-item label="所属客户" prop="use_code">
									<el-input size="mini" v-model="userEditForm.use_code"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="6">
								<el-form-item label="用户角色" prop="user_name_cn">
									<el-input size="mini" v-model="userEditForm.user_name_cn"></el-input>
								</el-form-item>
							</el-col>
						</el-row> -->
				</el-row>
				<!-- 表格-start -->
				<el-row style="margin-top: 15px">
                    <el-tabs type="border-card" v-model="activeName" @tab-click="handleClick">
                        <!-- <el-tab-pane label="操作权限" name="1">
                            <el-form :model="orgForm" :rules="orgFormRules" ref="orgFormRef" label-position="top">
                                <el-row>
                                    <el-col :span="6">
                                        <el-form-item label="默认组织" prop="use_code">
                                            <el-input size="mini" v-model="orgForm.use_code"></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <el-tree
                                        :props="props"
                                        :load="loadNode"
                                        lazy
                                        show-checkbox>
                                    </el-tree>
                                </el-row>
                            </el-form>
                        </el-tab-pane> -->
                      <el-tab-pane label="业务组织" name="1">
                            <el-form :model="orgForm" :rules="orgFormRules" ref="orgFormRef" label-position="top">
                                <el-row>
                                    <el-col :span="6">
                                        <el-form-item label="默认组织" prop="use_code">
                                            <el-input size="mini" v-model="orgForm.use_code"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="6">
                                        <el-form-item label="默认结算公司">
                                            <el-input size="mini" ></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="6">
                                        <el-form-item label="业务中心">
                                            <el-input size="mini"></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <el-tree
                                       :data="treeData"
                                        :props="defaultProps"
                                        @node-click="handleNodeClick"
                                        show-checkbox>
                                    </el-tree>
                                </el-row>
                            </el-form>
                        </el-tab-pane>
                        <el-tab-pane label="所属客户" name="2">
                            <el-form :model="orgForm" :rules="orgFormRules" ref="orgFormRef" label-position="top">
                            </el-form>
                        </el-tab-pane>
                        <el-tab-pane label="用户角色" name="3">
                            <el-form :model="ExternalCode" :rules="ExternalCodeRules" ref="ExternalCode" label-position="top">
                            </el-form>
                        </el-tab-pane>
                    </el-tabs>
				</el-row>
			</el-col>
		</el-form>
	</div>
</template>

<script>
import { queryDictRows } from '@/api/commonService';
import { getSysUser } from '@/api/system'
import router from '@/router';
import { Collapse } from 'element-ui';
	export default {
		data() {
			return {
                activeName: '1',
				userEditForm: {},
                sysUser: {},
				// 分页
				pageConfig: {
					layout: 'total, sizes, prev, pager, next, jumper',
					total: 0,
					pageSize: 10,
					pagerCount: 10,
					currentPage: 1,
					pageSizes: [10, 20, 50, 100]
				},
				// currentPage 改变时会触发
				// handleCurrentChange(val) {
				// 	console.log(`当前页: ${val}`)
				// 	this.pageConfig.currentPage = val
				// },
				// 校验
				userEditFormRules: {
                    use_code: [{ required: true, message: '' }],
                },
                orgForm: {},
                orgFormRules: {
                    use_code: [{ required: true, message: '' }],
                },
				// 表格数据
				userManagementTableDataSource: [],
				// 表格设置
				userManagementTableSettings: {
					height: 360,
					stretchH: 'all', // 根据宽度横向扩展，last:只扩展最后一列，none：默认不扩展
					...this.$systemConfig.tableConfig

				},
                userTypelist: [],
                inserviceStatus: [],
                sex: [],
                userSource: [],
                isActive: [],
                pickerOptions: {
                    disabledDate(time) {
                        return time.getTime() > Date.now();
                    },
                    shortcuts: [{
                        text: '今天',
                        onClick(picker) {
                        picker.$emit('pick', new Date());
                        }
                    }, {
                        text: '昨天',
                        onClick(picker) {
                        const date = new Date();
                        date.setTime(date.getTime() - 3600 * 1000 * 24);
                        picker.$emit('pick', date);
                        }
                    }, {
                        text: '一周前',
                        onClick(picker) {
                        const date = new Date();
                        date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
                        picker.$emit('pick', date);
                        }
                    }]
                },
                props: {
                    label: 'name',
                    children: 'zones',
                    isLeaf: 'leaf'
                },
                userRolesRequests: [],
                userRolesSettings: {
                    height: 170,
                    autoColumnSize: true,
                    stretchH: "none",
                    ...this.$systemConfig.tableConfig,
                },
                externalCodeRequests: [],
                externalCodeSettings: {
                    height: 170,
                    autoColumnSize: true,
                    stretchH: "none",
                    ...this.$systemConfig.tableConfig,
                },
                ExternalCode: {},
                ExternalCodeRules: {
                    use_code: [{ required: true, message: '' }],
                },
                treeData: [],
                 defaultProps: {
                    label: 'name',
                    children: 'sonList',
                  },
            }
		},
    async created() {

    },
		mounted() {
			let self = this
            console.log(self.$refs)
            self.getSelectList()
            if(self.$route.params && self.$route.params.sysUserId){
                let sysuser={
                    sysUserId: self.$route.params.sysUserId,
                    cascade: false,
                }
                    getSysUser(sysuser).then(res => {
                        self.sysUser=res.sysUser
                    })
            }
             let treeData= [{
            boName: null,
            childrenNodes: null,
            count: 0,
            custom: "01",
            hasCheckd: false,
            hasChildren: true,
            id: "6533953701609189377",
            isParent: true,
            level: null,
            name: "华贸股份",
            nodeType: "4",
            parentNode: null,
            pid: null,
            pidName: null,
            tableName: null,
            urlType: null,
               },
               {
            boName: null,
            childrenNodes: null,
            count: 0,
            custom: "0102",
            hasCheckd: false,
            hasChildren: false,
            id: "6807684394162294784",
            isParent: false,
            level: null,
            name: "HM总部职能",
            nodeType: "6",
            parentNode: null,
            pid: "6533953701609189377",
            pidName: "华贸股份",
            tableName: null,
            urlType: null
               }]
           let parentArr =treeData.filter(item => (item.pid === '' || item.pid === null || item.pid === undefined))
        //    console.log(parentArr)
           parentArr.forEach(item => {
               item.sonList = []
               treeData.forEach(sonItem => {
                   if(item.id === sonItem.pid) {
                       item.sonList.push(sonItem)
                   }
               })
           })
           this.treeData=parentArr
		},
		methods: {
            handleClick(){
                let self = this
                console.log(this.activeName)
                if(this.activeName === '2') {
                    		// 监听外层容器div宽度的变化，做表格自适应
            self.resizeObserver= new ResizeObserver((entries) => {
                self.$nextTick(() => {
           self.$refs.userManagementTableRef.resizeTo(entries[0].target.clientWidth)
            });
            });
            self.resizeObserver.observe(document.getElementById("userManagementContainer"));
                } else if(this.activeName === '3') {
                    // 监听外层容器div宽度的变化，做表格自适应
            self.resizeObserver= new ResizeObserver((entries) => {
                self.$nextTick(() => {
           self.$refs.externalcodeMaintenance.resizeTo(entries[0].target.clientWidth);
            });
            });
            self.resizeObserver.observe(document.getElementById("userManagementContainer"));
                }
            },
            loadNode(node, resolve) {
                if (node.level === 0) {
                return resolve([{ name: '华贸股份' }]);
                }
                if (node.level > 1) return resolve([]);

                setTimeout(() => {
                const data = [{
                    name: 'leaf',
                    leaf: true
                }, {
                    name: 'zone'
                }];

                resolve(data);
                }, 500);
            },
			// 新增
            handleAdd() {
                this.$router.push({
                    path: '/system/usermaintain'
                })
            },
            // 重置密码
            handleResetPwd() {

            },
            // 启用
            handleEnable() {

            },
            // 禁用
            handleDisable() {

            },
            // 查询
            handleQuery() {

            },
            // 重置
            handleReset() {

            },
            // pageSize 改变时会触发
            handleSizeChange(val) {
                console.log(`每页 ${val} 条`)
                this.pageConfig.pageSize = val
            },
            // currentPage 改变时会触发
            handleCurrentChange(val) {
                this.pageConfig.currentPage = val
            },
            //数据字典
            getSelectList(){
                let self=this;
                queryDictRows('Sex,InserviceStatus,UserType,UserSource,MD_CODE_DICT$MD_CODE_YESNO,MD_CODE_DICT$MD_USER_EXTERNAL_TYPE').then((res) => {
                   console.log(res)
                   self.userTypelist = res.UserType
                   self.inserviceStatus = res.InserviceStatus
                   self.sex = res.Sex
                   self.userSource = res.UserSource
                   self.isActive = res.MD_CODE_DICT$MD_CODE_YESNO
                })
            },
            addUesr(){
                let self=this;
                let addUesrObj={
                    characterName: '',
                    founder: '',
                    creationTime: '',
                    lastModifier: '',
                    modificationDate: '',
                }
                this.userRolesRequests.push(addUesrObj);
            },
            deleteUser(){
                const selections = this.$refs.userManagementTableRef.getSelections();
                let deleteList = [];
                let indexList = [];
                let userRolesRequests = this.userRolesRequests;
                if(selections &&selections.length>0){
                    selections.forEach(selection => {
                        if(selection.userRolesRequestsId){
                            deleteList.push(selection.userRolesId)
                        }
                        const index = userRolesRequests.indexOf(selection);
                        indexList.push(index);
                    });
                }else{
                    this.$coreMethods.message("warning", "请勾选一条记录");
                }
                if(deleteList && deleteList.length >0){
                }else{
                    let offset =0;
                    indexList.forEach((index) => {
                        userRolesRequests.splice(index - offset,1);
                        offset++;
                    })
                }
            },
            addExternalCode(){
                let self=this;
                let addExternalCodeObj={
                    externalCodeType: '',
                    externalCode: '',
                    externalCodeName: '',
                    userGroup: '',
                    founder: '',
                    creationTime: '',
                    lastModifier: '',
                    modificationDate: '',
                }
                this.externalCodeRequests.push(addExternalCodeObj);
            },
            deleteExternalCode(){
                const selections = this.$refs.externalcodeMaintenance.getSelections();
                let deleteList = [];
                let indexList = [];
                let externalCodeRequests = this.externalCodeRequests;
                if(selections &&selections.length>0){
                    selections.forEach(selection => {
                        if(selection.externalCodeRequestsId){
                            deleteList.push(selection.externalCodeId)
                        }
                        const index = externalCodeRequests.indexOf(selection);
                        indexList.push(index);
                    });
                }else{
                    this.$coreMethods.message("warning", "请勾选一条记录");
                }
                if(deleteList && deleteList.length >0){
                }else{
                    let offset =0;
                    indexList.forEach((index) => {
                        externalCodeRequests.splice(index - offset,1);
                        offset++;
                    })
                }
            },
            handleNodeClick(treeData){
             console.log(treeData);
            },
		}
	};
</script>

<style scoped lang="less">

</style>
